import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseTextArea',
    props: {
        placeholder: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: false,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
                                                                          
            return (_openBlock(), _createBlock(_component_v_textarea, {
                class: "textAreaMySwooopStyle showValidationErrorsCssOverride",
                "v-model": __props.message,
                name: props.name,
                placeholder: props.placeholder,
                label: props.label,
                density: "compact"
            }, null, 8, ["v-model", "name", "placeholder", "label"]));
        };
    }
});


/* Vuetify */
import { VTextarea as _component_v_textarea } from "vuetify/lib/components/VTextarea/index.mjs"

